<template>
  <div class="pd-top-15">
    <page-layout
      :breadcrumbs="[
        {
          text: this.$t('navDrawer.home').toUpperCase(),
          disabled: false,
          to: {name: 'home'},
          exact: true
        },
        {
          text: localization.title.toUpperCase(),
          disabled: true,
          exact: false
        }
      ]"
    >
      <o-main-progress
        v-if="loading"
      />
      <v-row
        v-else
        wrap no-gutters class="py-2"
      >
        <v-col cols="12">
          <v-form
            ref="form"
            v-model="valid" 
            id="valid"
            lazy-validation
          >
            <v-tabs
              v-model="seccionActual" 
              id="seccionActual"
              vertical
              background-color="transparent"
              class="transparentTabs"
            >
              <v-tab
                v-for="(item, index) in items"
                :key="index + '-tab'"
              >
                <v-row justify="center" align="center">
                  {{getNombreConCambios(item, index)}}
                </v-row>
              </v-tab>
              <v-btn
                @click="guardarCambios"
                color="primary"
                class="mt-2"
                :disabled="!cambiadoAlert || loading || saving"
                :loading="loading || saving"
              >
                {{localization.tabsTitles.button}}
              </v-btn>
              <v-tab-item
                v-for="(item, index) in items"
                :key="index + '-tab-item'"
              >
                <v-container fluid>
                  <component
                    :is="item.tipo"
                    :saving="saving"
                    :valid="valid"
                    :configuracion.sync="configuracion"
                    :cambiado="cambiado[index]"
                    @cambiado="updateCambiado($event, index)"
                    @toggleValidProp="toggleValidProp($event)"
                    @actualizarCamposObligatorios="actualizarCamposObligatorios($event, index)"
                  />
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-form>
        </v-col>
      </v-row>
    </page-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import general from './general'
import comunicacionProveedor from './emailProveedor'
import camposObligatorios from './camposObligatorios'
import estructuraDescargaDocumentos from './estructuraDescargaDocumentos'
import portalCliente from './portalCliente'
import portalWeb from './portalWeb'
import tiposSolicitudes from './tiposSolicitudes'
import alertBeforeExit from '@/mixins/alertBeforeExit'

export default {
  mixins: [alertBeforeExit],
  components: {
    general,
    comunicacionProveedor,
    estructuraDescargaDocumentos,
    camposObligatorios,
    portalWeb,
    portalCliente,
    tiposSolicitudes
  },
  beforeCreate() {
    let idubapi = JSON.parse(localStorage.idubapi)
    if (idubapi.restriccionesCliente.restringirAccesoConfigPV == 1) {
      this.$router.push({ name: 'home' })
    }
  },
  data () {
    return {
      seccionActual: 0,
      configuracion: {},
      loading: false,
      saving: false,
      cambiado: [false, false, false, false, false],
      valid: true,
      promocionesTiposVisitaDefault: {
        'preVenta': [],
        'postVenta': [],
        'preEntrega': []
      },
      promocionesTiposVisitaDefaultWeb: {
        'preVenta': [],
        'postVenta': [],
        'preEntrega': []
      },
    }
  },
  async created () {
    const loader = this.$loading.show({
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false
    })

    try {
      await this.getTiposSolicitudes()
      this.loading = true
      await this.loadConfiguracion()
      await this.loadTiposVisita()
      await this.obtenerEstructuraDescargaDocumentos()
      await this.getEstados()
      try {
        await this.obtenerPromocionesTiposVisita('APP')
        await this.obtenerPromocionesTiposVisita('WEB')
        
        await this.obtenerPromocionesTiposSolicitudCliente('APP')
        await this.obtenerPromocionesTiposSolicitudCliente('WEB')
        
      } catch (error) {
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.inicializarObjetoConfig()
    } catch (error) {
      this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
    }
    this.loading = false
    loader.hide()
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi',
      configuracionStore: 'configuracion/getConfiguracion',
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      allTiposSolicitud: 'configuracion/getAllTiposSolicitud',
      estructuraDescargaDocumentos: 'configuracion/getEstructuraDescargaDocumentos',
      promocionesTiposVisita: 'configuracion/getPromocionesTiposVisita',
      promocionesTiposVisitaWeb: 'configuracion/getPromocionesTiposVisitaWeb',
      promocionesTiposSolicitudCliente: 'configuracion/getPromocionesTiposSolicitudCliente',
      promocionesTiposSolicitudClienteWeb: 'configuracion/getPromocionesTiposSolicitudClienteWeb',
      tipoSolicitudesCliente: 'configuracion/getTiposSolicitudCliente',
      tipoSolicitudesClienteWeb: 'configuracion/getTiposSolicitudClienteWeb'
    }),
    localization () {
      return this.$t('sectionConfiguracion')
    },
    items () {
      let usuario = JSON.parse(localStorage.usuario)
      let entornos = usuario.entornos
      let rolCliente = false
      let pvSinBO = false

      entornos.forEach(entorno => {
        if (entorno.idubapi == this.$store.state.login.credentials.idubapi) {
          rolCliente = entorno.rolCliente
          pvSinBO = (this.idubapi.motor === 'SIN_BD')
        }
      });

      if(pvSinBO) {
        return [
          {
            name: this.localization.tabsTitles.general,
            tipo: 'general'
          },
          {
            name: this.localization.tabsTitles.tiposSolicitudes,
            tipo: 'tiposSolicitudes'
          },
          {
            name: this.localization.tabsTitles.campos,
            tipo: 'camposObligatorios'
          },
                  {
            name: this.localization.tabsTitles.comunicacionProveedor,
            tipo: 'comunicacionProveedor'
          },
          {
            name: this.localization.tabsTitles.estructuraDescargaDocumentos,
            tipo: 'estructuraDescargaDocumentos'
          }
        ]
      }

      if ( rolCliente === true ) {
        return [
          {
            name: this.localization.tabsTitles.general,
            tipo: 'general'
          },
          {
            name: this.localization.tabsTitles.tiposSolicitudes,
            tipo: 'tiposSolicitudes'
          },
          {
            name: this.localization.tabsTitles.campos,
            tipo: 'camposObligatorios'
          },
                  {
            name: this.localization.tabsTitles.comunicacionProveedor,
            tipo: 'comunicacionProveedor'
          },
          {
            name: this.localization.tabsTitles.estructuraDescargaDocumentos,
            tipo: 'estructuraDescargaDocumentos'
          },
          {
            name: this.localization.tabsTitles.portal,
            tipo: 'portalCliente'
          },
          {
            name: this.localization.tabsTitles.web,
            tipo: 'portalWeb'
          }
        ]
      }
      else {
        return [
          {
            name: this.localization.tabsTitles.general,
            tipo: 'general'
          },
          {
            name: this.localization.tabsTitles.tiposSolicitudes,
            tipo: 'tiposSolicitudes'
          },
          {
            name: this.localization.tabsTitles.campos,
            tipo: 'camposObligatorios'
          },
                  {
            name: this.localization.tabsTitles.comunicacionProveedor,
            tipo: 'comunicacionProveedor'
          },
          {
            name: this.localization.tabsTitles.estructuraDescargaDocumentos,
            tipo: 'estructuraDescargaDocumentos'
          },
          {
            name: this.localization.tabsTitles.portal,
            tipo: 'portalCliente'
          }
        ]
      }
    },
    usuario () {
      return JSON.parse(localStorage.usuario)
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadTiposVisita: 'incidencias/getVisitTypes',
      loadConfiguracion: 'configuracion/obtenerConfiguracion',
      guardarConfiguracion: 'configuracion/guardarConfiguracion',
      getTiposSolicitudes: 'configuracion/obtenerTiposSolicitud',
      guardarTiposSolicitudes: 'configuracion/guardarTiposSolicitudes',
      guardarPromocionesTiposVisita: 'configuracion/guardarPromocionesTiposVisita',
      guardarPromocionesTiposVisitaWeb: 'configuracion/guardarPromocionesTiposVisitaWeb',
      guardarPromocionesTiposSolicitudCliente: 'configuracion/guardarPromocionesTiposSolicitudCliente',
      guardarPromocionesTiposSolicitudClienteWeb: 'configuracion/guardarPromocionesTiposSolicitudClienteWeb',
      obtenerModulosPortalCliente:'configuracion/obtenerModulosPortalCliente',
      // obtenerOficioAltaSolicitudes:'configuracion/obtenerOficioAltaSolicitudes',
      delPromotionsProvider: 'configuracion/delPromotionsProvider',
      guardarEstructuraDescargaDocumentos: 'configuracion/guardarEstructuraDescargaDocumentos',
      obtenerEstructuraDescargaDocumentos: 'configuracion/obtenerEstructuraDescargaDocumentos',
      getEstados: 'incidencias/getStatusTypes',
      obtenerPromocionesTiposVisita: 'configuracion/obtenerPromocionesTiposVisita',
      obtenerPromocionesTiposSolicitudCliente: 'configuracion/obtenerPromocionesTiposSolicitudCliente'
    }),
    inicializarObjetoConfig () {
      // este parametro se considera habilitado cuando:
      // a: tiene VBCliente
      // b: no tiene VBCliente pero tiene activo cierre o rechazo -- este caso, tambien activa el parametro desdeTerminado
      console.log('inicializarObjetoConfig')
      let habilitarOpcionesConformidad = (this.configuracionStore.configVistoBuenoCliente || (this.configuracionStore.clientesCerrar || this.configuracionStore.clientesRechazar))
      let habilitarOpcionesConformidadWeb = (this.configuracionStore.configVistoBuenoClienteWeb || (this.configuracionStore.clientesCerrarWeb || this.configuracionStore.clientesRechazarWeb))
      let desdeTerminado = (!this.configuracionStore.configVistoBuenoCliente && (this.configuracionStore.clientesCerrar || this.configuracionStore.clientesRechazar))
      let desdeTerminadoWeb = (!this.configuracionStore.configVistoBuenoClienteWeb && (this.configuracionStore.clientesCerrarWeb || this.configuracionStore.clientesRechazarWeb))
      this.configuracion = {
        camposIncidencia: this.configuracionStore.camposIncidencia.slice(),
        camposObligatorios: this.configuracionStore.camposObligatorios.slice(),
        emailProveedor: this.configuracionStore.emailProveedor,
        diasRegistroCierre: this.configuracionStore.diasRegistroCierre,
        permitirEnvioMasivo: this.configuracionStore.permitirEnvioMasivo,
        mostrarObservacionesParteMono: this.configuracionStore.mostrarObservacionesParteMono,
        envioEmailAutomatico: this.configuracionStore.envioEmailAutomatico,
        asignarProveedorAuto: this.configuracionStore.asignarProveedorAuto,
        descargaImagenesPrimeraIncidencia: !this.configuracionStore.descargaImagenesPrimeraIncidencia,
        proveedorVisitador: this.configuracionStore.proveedorVisitador,
        permitirAsignarPromocionesProveedor: this.configuracionStore.permitirAsignarPromocionesProveedor,
        generarParteAlta: this.configuracionStore.generarParteAlta,
        permitirCierreProveedorVisitador: this.configuracionStore.permitirCierreProveedorVisitador,
        obligatorioAdjuntarImgAltaSolicitud: this.configuracionStore.obligatorioAdjuntarImgAltaSolicitud,
        obligatorioIncorporarDatosClienteCierre: this.configuracionStore.obligatorioIncorporarDatosClienteCierre,
        descripcionTextoConformidad: this.configuracionStore.descripcionTextoConformidad,
        permitirChat: this.configuracionStore.permitirChat,
        maxIncidenciasFicha: this.configuracionStore.maxIncidenciasFicha,
        mostrarOficio: this.configuracionStore.mostrarOficio,
        mostrarOficioWeb: this.configuracionStore.mostrarOficioWeb,
        clienteCrearIncidencias: this.configuracionStore.clienteCrearIncidencias,
        clienteCrearIncidenciasWeb: this.configuracionStore.clienteCrearIncidenciasWeb,
        diasCierre: this.configuracionStore.diasCierre,
        diasCierreWeb: this.configuracionStore.diasCierreWeb,
        clientesVer: this.configuracionStore.clientesVer,
        clientesVerWeb: this.configuracionStore.clientesVerWeb,
        clientesRechazarDesdeVB: (!desdeTerminado) ? this.configuracionStore.clientesRechazar : false,
        clientesRechazarDesdeVB_WEB: (!desdeTerminadoWeb) ? this.configuracionStore.clientesRechazarWeb : false,
        clientesCerrarDesdeVB: (!desdeTerminado) ? this.configuracionStore.clientesCerrar : false,
        clientesCerrarDesdeVB_WEB: (!desdeTerminadoWeb) ? this.configuracionStore.clientesCerrarWeb : false,
        clientesRechazarDesdeTerminado: (desdeTerminado) ? this.configuracionStore.clientesRechazar : false,
        clientesRechazarDesdeTerminadoWeb: (desdeTerminadoWeb) ? this.configuracionStore.clientesRechazarWeb : false,
        clientesCerrarDesdeTerminado: (desdeTerminado) ? this.configuracionStore.clientesCerrar : false,
        clientesCerrarDesdeTerminadoWeb: (desdeTerminadoWeb) ? this.configuracionStore.clientesCerrarWeb : false,
        clienteEditarSolicitudes: this.configuracionStore.clienteEditarSolicitudes,
        clienteEditarSolicitudesNoEvaluadas: this.configuracionStore.clienteEditarSolicitudesNoEvaluadas,
        clienteEditarSolicitudesEditarFotosGuardadas: this.configuracionStore.clienteEditarSolicitudesEditarFotosGuardadas,
        clienteEditarSolicitudesBorrarIncidencia: this.configuracionStore.clienteEditarSolicitudesBorrarIncidencia,
        origenIncidencia: this.configuracionStore.origenIncidencia,
        origenIncidenciaWeb: this.configuracionStore.origenIncidenciaWeb,
        estadoIncidencia: this.configuracionStore.estadoIncidencia,
        estadoIncidenciaWeb: this.configuracionStore.estadoIncidenciaWeb,
        tipoVisitaIncidencia: this.configuracionStore.tipoVisitaIncidencia,
        tipoVisitaIncidenciaWeb: this.configuracionStore.tipoVisitaIncidenciaWeb,
        mostrarObservaciones: this.configuracionStore.mostrarObservaciones,
        mostrarObservacionesEstados: this.configuracionStore.mostrarObservacionesEstados,
        mostrarObservacionesWeb: this.configuracionStore.mostrarObservacionesWeb,
        diasVisibleCliente: this.configuracionStore.diasVisibleCliente,
        diasVisibleClienteWeb: this.configuracionStore.diasVisibleClienteWeb,
        ocultarProveedorHoras: this.configuracionStore.ocultarProveedorHoras,
        ocultarResponsable: this.configuracionStore.ocultarResponsable,
        configVistoBuenoCliente: this.configuracionStore.configVistoBuenoCliente,
        configVistoBuenoClienteWeb: this.configuracionStore.configVistoBuenoClienteWeb,
        permitirIncidenciasRechazado: this.configuracionStore.permitirIncidenciasRechazado,
        tiposIncidenciaAlquiler: this.configuracionStore.tiposIncidenciaAlquiler.slice(),
        tiposIncidenciaSinOperacion: this.configuracionStore.tiposIncidenciaSinOperacion.slice(),
        tiposIncidenciaVenta: this.configuracionStore.tiposIncidenciaVenta.slice(),
        tiposVisita: this.configuracionStore.tiposVisita.slice(),
        tiposVisitaEmailAutomatico: this.configuracionStore.tiposVisitaEmailAutomatico.slice(),
        transitoLibreEstados: this.configuracionStore.transitoLibreEstados,
        PV_LIMITE_SOLICITUDES: this.configuracionStore.PV_LIMITE_SOLICITUDES,
        PV_DIRECCION_DATOS_IDENTIFICACION: this.configuracionStore.PV_DIRECCION_DATOS_IDENTIFICACION,
        PV_PERMITIR_BORRAR_MAESTROS_CON_INCI: this.configuracionStore.PV_PERMITIR_BORRAR_MAESTROS_CON_INCI,
        PV_PDC_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR: this.configuracionStore.PV_PDC_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR,
        PV_CLIENTE_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR: this.configuracionStore.PV_CLIENTE_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR,
        PV_APP_ENVIO_RESUMEN_SUPERVISOR: this.configuracionStore.PV_APP_ENVIO_RESUMEN_SUPERVISOR,
        PV_WEB_ENVIO_RESUMEN_SUPERVISOR: this.configuracionStore.PV_WEB_ENVIO_RESUMEN_SUPERVISOR,
        PV_ACTIVAR_ENCUESTA: this.configuracionStore.PV_ACTIVAR_ENCUESTA,
        PV_INFORME_NOTAS: this.configuracionStore.PV_INFORME_NOTAS,
        PV_INFORME_OBSERVACIONES: this.configuracionStore.PV_INFORME_OBSERVACIONES,
        PV_VISITA_FECHA_ALTA_CLIENTE: this.configuracionStore.PV_VISITA_FECHA_ALTA_CLIENTE,
        PV_VISITA_REGISTRO_ENTRADA: this.configuracionStore.PV_VISITA_REGISTRO_ENTRADA,
        PV_RESTRINGIR_NOTAS_A_PROVEEDORES: this.configuracionStore.PV_RESTRINGIR_NOTAS_A_PROVEEDORES,
        PV_MAIL_DESCRIPCION: this.configuracionStore.PV_MAIL_DESCRIPCION,
        PV_MAIL_DATOS_CLIENTE: this.configuracionStore.PV_MAIL_DATOS_CLIENTE,
        PV_TEXTO_PIE_RESUMEN: this.configuracionStore.PV_TEXTO_PIE_RESUMEN,
        visualizarFiltroEvaluado: this.configuracionStore.visualizarFiltroEvaluado,
        PV_BLOQUEO_CAMPO_DESCRIPCION_CLIENTE: this.configuracionStore.PV_BLOQUEO_CAMPO_DESCRIPCION_CLIENTE,
        PV_BLOQUEO_CAMPO_DESCRIPCION_WEB: this.configuracionStore.PV_BLOQUEO_CAMPO_DESCRIPCION_WEB,
        PV_PERMISOS_EXTRA_PROVEEDOR: this.configuracionStore.PV_PERMISOS_EXTRA_PROVEEDOR,
        PV_TRANSITO_ESTADOS_PROVEEDOR: this.configuracionStore.PV_TRANSITO_ESTADOS_PROVEEDOR,
        PV_ALTA_ACTOR_PROVEEDOR: this.configuracionStore.PV_ALTA_ACTOR_PROVEEDOR,
        habilitarOpcionesConformidad: habilitarOpcionesConformidad,
        habilitarOpcionesConformidadWeb: habilitarOpcionesConformidadWeb,
        desdeTerminado: desdeTerminado,
        desdeTerminadoWeb: desdeTerminadoWeb,
        bloquearChatCerradas: this.configuracionStore.bloquearChatCerradas,
        deletePromotionsProveedor: false,
        PV_IMPORTACION_CERRADAS:this.configuracionStore.PV_IMPORTACION_CERRADAS,
        tiposSolicitudes: this.allTiposSolicitud.map(x => {
          return {
            habilitar: x.habilitar,
            habilitarCliente: x.habilitarCliente,
            habilitarClienteWeb: x.habilitarClienteWeb,
            nombre: x.descripcionTipoSolicitud,
            nombreBase: x.descripcionTipoSolicitud,
            idTipoSolicitud: x.idtipoSolicitud,
            codigoTipoSolicitud: x.codigoTipoSolicitud,
            translates: x.translates
          }
        }),
        estructuraDescargaDocumentos: this.estructuraDescargaDocumentos.length > 0 ? this.estructuraDescargaDocumentos : [
          { id: 1, codigo: "promocion", descripcion: "Promocion", orden: 1, name: "Promocion", excluida: false},
          { id: 2, codigo: "inmueble", descripcion: "Inmueble", orden: 2, name: "Inmueble", excluida: false },
          { id: 3, codigo: "visita", descripcion: "Visita", orden: 3, name: "Visita", excluida: false },
          { id: 4, codigo: "incidencia", descripcion: "Incidencia", orden: 4, name: "Incidencia", excluida: false },
          { id: 5, codigo: "tipoDocumento", descripcion: "TipoDocumento", orden: 5, name: "Tipo documento", excluida: false },
          { id: 6, codigo: "oficio",  descripcion: "Oficio", orden: 6, name: "Oficio", excluida: true },
        ],
        promocionesTipoVisita: (this.promocionesTiposVisita != null )  ? this.promocionesTiposVisita : this.promocionesTiposVisitaDefault,
        promocionesTipoVisitaWeb: (this.promocionesTiposVisitaWeb != null )  ? this.promocionesTiposVisitaWeb : this.promocionesTiposVisitaDefaultWeb,
        promocionesTipoSolicitudCliente: (this.promocionesTiposSolicitudCliente != null ) ? this.promocionesTiposSolicitudCliente : [],
        promocionesTipoSolicitudClienteWeb: (this.promocionesTiposSolicitudClienteWeb != null ) ? this.promocionesTiposSolicitudClienteWeb : []
      }
    },
    getNombreConCambios (item, index) {
      return item.name + (this.cambiado[index] ? ' *' : '  ')
    },
    updateCambiado (val, index) {
      this.cambiado[index] = val
      this.cambiadoAlert = this.cambiado.includes(true)
    },
    toggleValidProp (val) {
      this.valid = val
    },
    actualizarCamposObligatorios (val) {
      this.configuracion.camposObligatorios = val
    },
    async guardarCambios () {
      try {
        if(!this.$refs.form.validate()) {
        this.addAlert({ texto: this.$t('revisarCamposRojo'), color: 'error' })
          return
        }

        //comprobamos que tengan sentido las configuraciones de PDC
        if(this.configuracion.habilitarOpcionesConformidad && !this.configuracion.desdeTerminado && !this.configuracion.configVistoBuenoCliente) {
          this.addAlert({ texto: this.$t('habilitaConformidadCliente'), color: 'error' })
          return
        }

        if(this.configuracion.habilitarOpcionesConformidadWeb && !this.configuracion.desdeTerminadoWeb && !this.configuracion.configVistoBuenoClienteWeb) {
          this.addAlert({ texto: this.$t('habilitaConformidadClienteWEB'), color: 'error' })
          return
        }

        //comprobamos que tengan sentido las configuraciones de PDC
        if((this.configuracion.desdeTerminado && !this.configuracion.clientesRechazarDesdeTerminado && !this.configuracion.clientesCerrarDesdeTerminado) || (this.configuracion.configVistoBuenoCliente && !this.configuracion.clientesRechazarDesdeVB && !this.configuracion.clientesCerrarDesdeVB)) {
          this.addAlert({ texto: this.$t('habilitaConformidadClienteSinAccion'), color: 'error' })
          return
        }
        //comprobamos que tengan sentido las configuraciones de PDC
        if((this.configuracion.desdeTerminadoWeb && !this.configuracion.clientesRechazarDesdeTerminadoWeb && !this.configuracion.clientesCerrarDesdeTerminadoWeb) || (this.configuracion.configVistoBuenoClienteWeb && !this.configuracion.clientesRechazarDesdeVB_WEB && !this.configuracion.clientesCerrarDesdeVB_WEB)) {
          this.addAlert({ texto: this.$t('habilitaConformidadClienteWebSinAccion'), color: 'error' })
          return
        }
        if ( this.configuracion.mostrarObservaciones && this.configuracion.mostrarObservacionesEstados.length === 0 ) {
          this.addAlert({ texto: this.$t('seleccionaEstadosObservaciones'), color: 'error' })
          return
        }

        this.saving = true
        
         // Espera a que el watcher responda (simulado con setTimeout)
        await new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });
        
        if ( this.valid === false) {
          this.addAlert({ texto: this.$t('revisarCamposRojo'), color: 'error' })
          this.saving = false
          return
        }

        var tiposIncidenciaAlquiler = [
          (this.configuracion.tiposIncidenciaAlquiler.includes('1')) ? 1 : '',
          (this.configuracion.tiposIncidenciaAlquiler.includes('2')) ? 2 : '',
          (this.configuracion.tiposIncidenciaAlquiler.includes('3')) ? 3 : ''
        ]
        var tiposIncidenciaSinOperacion = [
          (this.configuracion.tiposIncidenciaSinOperacion.includes('1')) ? 1 : '',
          (this.configuracion.tiposIncidenciaSinOperacion.includes('2')) ? 2 : '',
          (this.configuracion.tiposIncidenciaSinOperacion.includes('3')) ? 3 : ''
        ]

        var tiposIncidenciaVenta = [
          (this.configuracion.tiposIncidenciaVenta.includes('1')) ? 1 : '',
          (this.configuracion.tiposIncidenciaVenta.includes('2')) ? 2 : '',
          (this.configuracion.tiposIncidenciaVenta.includes('3')) ? 3 : ''
        ]
        
        let clientesRechazar = (this.configuracion.configVistoBuenoCliente) ? this.configuracion.clientesRechazarDesdeVB : this.configuracion.clientesRechazarDesdeTerminado
        let clientesRechazarWeb = (this.configuracion.configVistoBuenoClienteWeb) ? this.configuracion.clientesRechazarDesdeVB_WEB : this.configuracion.clientesRechazarDesdeTerminadoWeb
        let clientesCerrar = (this.configuracion.configVistoBuenoCliente) ? this.configuracion.clientesCerrarDesdeVB : this.configuracion.clientesCerrarDesdeTerminado
        let clientesCerrarWeb = (this.configuracion.configVistoBuenoClienteWeb) ? this.configuracion.clientesCerrarDesdeVB_WEB : this.configuracion.clientesCerrarDesdeTerminadoWeb
        let tiposVisitaPDC = this.configuracion.tipoVisitaIncidencia.filter(item => {
          return item === '1' || item === '2' || item === '3'
        })
        let tiposVisitaPDC_WEB = this.configuracion.tipoVisitaIncidenciaWeb.filter(item => {
          return item === '1' || item === '2' || item === '3'
        })
        // si this.configuracion.mostrarObservacionesEstados es array hacemos join
        let obsCambioEstado = []
        if(Array.isArray(this.configuracion.mostrarObservacionesEstados)) {
          obsCambioEstado = this.configuracion.mostrarObservacionesEstados
        }
        
        // 
        const obj = {
          PV_CAMPOS_OBLIGATORIOS: this.configuracion.camposObligatorios.join('|'),
          PV_CUERPO_EMAIL_PARTE_PROVEEDOR: this.configuracion.emailProveedor,
          PV_DIAS_FECHA_PREVISTA: this.configuracion.diasRegistroCierre,
          PV_ENVIO_MASIVO_PARTES: this.configuracion.permitirEnvioMasivo ? 'S' : 'N',
          PV_MOSTRAR_OBSERVACIONES_PARTE: this.configuracion.mostrarObservacionesParteMono ? 'S' : 'N',
          PV_MAIL_AUTOMATICO_ALTA: this.configuracion.envioEmailAutomatico ? 'S' : 'N',
          PV_NUM_MAX_INCIDENCIAS_FICHA: this.configuracion.maxIncidenciasFicha,
          PV_PDC_OFICIO_EN_ALTA: this.configuracion.mostrarOficio ? 'S' : 'N',
          PV_WEB_PDC_OFICIO_EN_ALTA: this.configuracion.mostrarOficioWeb ? 'S' : 'N',
          PV_PDC_MOSTRAR_OBSERVACIONES: this.configuracion.mostrarObservaciones ? 'S' : 'N',
          PV_PDC_MOSTRAR_OBSERVACIONES_ESTADOS: obsCambioEstado.join('|'),
          PV_WEB_PDC_MOSTRAR_OBSERVACIONES: this.configuracion.mostrarObservacionesWeb ? 'S' : 'N',
          PV_PERMITIR_ALTA_INCIDENCIA_RECHAZADA: this.configuracion.permitirIncidenciasRechazado ? 'S' : 'N',
          PV_TIPO_INCIDENCIA_ALQ: tiposIncidenciaAlquiler.join('|'),
          PV_TIPO_INCIDENCIA_SIN_OPER: tiposIncidenciaSinOperacion.join('|'),
          PV_TIPO_INCIDENCIA_VTA: tiposIncidenciaVenta.join('|'),
          PV_TIPO_VISITA_MAIL_AUTOMATICO: this.configuracion.tiposVisitaEmailAutomatico.join('|'),
          PV_TRANSITO_LIBRE_ESTADOS: this.configuracion.transitoLibreEstados ? 'S' : 'N',
          PV_CIERRE_CLIENTE: this.configuracion.configVistoBuenoCliente ? 'S' : 'N',
          PV_WEB_CIERRE_CLIENTE: this.configuracion.configVistoBuenoClienteWeb ? 'S' : 'N',
          PV_DIAS_DESDE_CIERRE: this.configuracion.diasCierre,
          PV_WEB_DIAS_DESDE_CIERRE: this.configuracion.diasCierreWeb,
          PV_ASIGNAR_SI_PROVEEDOR_UNICO: this.configuracion.asignarProveedorAuto ? 'S' : 'N',
          PV_OMITIR_IMAGENES_PRIMERA_SINCRONIZACION: this.configuracion.descargaImagenesPrimeraIncidencia ? 'N' : 'S',
          PV_PROVEEDOR_VISITADOR: this.configuracion.proveedorVisitador ? 'S' : 'N',
          PV_OBLIGATORIO_ADJUNTAR_IMAGEN_ALTA_SOLICITUD: this.configuracion.obligatorioAdjuntarImgAltaSolicitud ? 'S' : 'N',
          PV_PERMITIR_ASIGNAR_PROMOCIONES_PROVEEDOR: this.configuracion.permitirAsignarPromocionesProveedor ? 'S' : 'N',
          PV_GENERAR_PARTE_ALTA: this.configuracion.generarParteAlta ? 'S' : 'N',
          PV_INCORPORAR_DATOS_CLIENTE_CIERRE: this.configuracion.obligatorioIncorporarDatosClienteCierre ? 'S' : 'N',
          PV_DESCRIPCION_TEXTO_CONFORMIDAD: this.configuracion.descripcionTextoConformidad,
          PV_PERMITIR_CHAT: this.configuracion.permitirChat ? 'S' : 'N',
          PV_PDC_CLIENTE_CREAR_INCIDENCIAS: this.configuracion.clienteCrearIncidencias  ? 'S' : 'N',
          PV_WEB_PDC_CLIENTE_CREAR_INCIDENCIAS: this.configuracion.clienteCrearIncidenciasWeb  ? 'S' : 'N',
          PV_PDC_CLIENTE_RECHAZA_INCIDENCIAS: clientesRechazar  ? 'S' : 'N',
          PV_WEB_PDC_CLIENTE_RECHAZA_INCIDENCIAS: clientesRechazarWeb  ? 'S' : 'N',
          PV_PDC_CLIENTE_VER_INCIDENCIAS: this.configuracion.clientesVer  ? 'S' : 'N',
          PV_WEB_PDC_CLIENTE_VER_INCIDENCIAS: this.configuracion.clientesVerWeb  ? 'S' : 'N',
          PV_PDC_ORIGEN_INCIDENCIA: this.configuracion.origenIncidencia.join('|'),
          PV_WEB_PDC_ORIGEN_INCIDENCIA: this.configuracion.origenIncidenciaWeb.join('|'),
          PV_PDC_ESTADO_INCIDENCIA: this.configuracion.estadoIncidencia.join('|'),
          PV_WEB_PDC_ESTADO_INCIDENCIA: this.configuracion.estadoIncidenciaWeb.join('|'),
          PV_PDC_TIPOS_VISITA_INCIDENCIA: tiposVisitaPDC.join('|'),
          PV_WEB_PDC_TIPOS_VISITA_INCIDENCIA: tiposVisitaPDC_WEB.join('|'),
          PV_PDC_CLIENTE_EDITA_INCIDENCIAS: this.configuracion.clienteEditarSolicitudes  ? 'S' : 'N',
          PV_PDC_CLIENTE_EDITA_INCIDENCIAS_NO_EVALUADAS: this.configuracion.clienteEditarSolicitudesNoEvaluadas ? 'S' : 'N',
          PV_PDC_CLIENTE_EDITA_INCIDENCIAS_EDITAR_FOTOS_GUARDADAS: this.configuracion.clienteEditarSolicitudesEditarFotosGuardadas ? 'S' : 'N',
          PV_PDC_CLIENTE_EDITA_INCIDENCIAS_BORRAR_INCIDENCIA: this.configuracion.clienteEditarSolicitudesBorrarIncidencia ? 'S' : 'N',
          PV_PDC_CLIENTE_CERRAR_INCIDENCIAS: clientesCerrar  ? 'S' : 'N',
          PV_WEB_PDC_CLIENTE_CERRAR_INCIDENCIAS: clientesCerrarWeb  ? 'S' : 'N',
          PV_PDC_CLIENTE_DIAS_VISIBLE: this.configuracion.diasVisibleCliente,
          PV_WEB_CLIENTE_DIAS_VISIBLE: this.configuracion.diasVisibleClienteWeb,
          PV_WEB_OCULTAR_PROVEEDOR_HORAS: this.configuracion.ocultarProveedorHoras ? 'S' : 'N',
          PV_WEB_OCULTAR_RESPONSABLE: this.configuracion.ocultarResponsable ? 'S' : 'N',
          PV_CODIGO_PROPIO_NOMBRE: this.configuracion.codigoPropioNombre,
          PV_LIMITE_SOLICITUDES: this.configuracion.PV_LIMITE_SOLICITUDES,
          PV_DIRECCION_DATOS_IDENTIFICACION: this.configuracion.PV_DIRECCION_DATOS_IDENTIFICACION  ? 'S' : 'N',
          PV_PERMITIR_BORRAR_MAESTROS_CON_INCI: this.configuracion.PV_PERMITIR_BORRAR_MAESTROS_CON_INCI ? 'S' : 'N',
          PV_PDC_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR: this.configuracion.PV_PDC_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR ? 'S' : 'N',
          PV_CLIENTE_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR: this.configuracion.PV_CLIENTE_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR ? 'S' : 'N',
          PV_APP_ENVIO_RESUMEN_SUPERVISOR: this.configuracion.PV_APP_ENVIO_RESUMEN_SUPERVISOR ? 'S' : 'N',
          PV_WEB_ENVIO_RESUMEN_SUPERVISOR: this.configuracion.PV_WEB_ENVIO_RESUMEN_SUPERVISOR ? 'S' : 'N',
          PV_ACTIVAR_ENCUESTA: this.configuracion.PV_ACTIVAR_ENCUESTA ? 'S' : 'N',
          PV_INFORME_NOTAS: this.configuracion.PV_INFORME_NOTAS ? 'S' : 'N',
          PV_INFORME_OBSERVACIONES: this.configuracion.PV_INFORME_OBSERVACIONES ? 'S' : 'N',
          PV_VISITA_FECHA_ALTA_CLIENTE: this.configuracion.PV_VISITA_FECHA_ALTA_CLIENTE ? 'S' : 'N',
          PV_VISITA_REGISTRO_ENTRADA: this.configuracion.PV_VISITA_REGISTRO_ENTRADA ? 'S' : 'N',
          PV_RESTRINGIR_NOTAS_A_PROVEEDORES: this.configuracion.PV_RESTRINGIR_NOTAS_A_PROVEEDORES ? 'S' : 'N',
          PV_MAIL_DESCRIPCION: this.configuracion.PV_MAIL_DESCRIPCION ? 'S' : 'N',
          PV_MAIL_DATOS_CLIENTE: this.configuracion.PV_MAIL_DATOS_CLIENTE ? 'S' : 'N',
          PV_TEXTO_PIE_RESUMEN: this.configuracion.PV_TEXTO_PIE_RESUMEN,
          PV_WEB_PDC_BLOQUEAR_CHAT_INCIDENCIAS_CERRADAS: this.configuracion.bloquearChatCerradas ? 'S' : 'N',
          PV_VISUALIZAR_FILTRO_EVALUADO: this.configuracion.visualizarFiltroEvaluado ? 'S' : 'N',
          PV_BLOQUEO_CAMPO_DESCRIPCION_CLIENTE: this.configuracion.PV_BLOQUEO_CAMPO_DESCRIPCION_CLIENTE ? 'S' : 'N',
          PV_BLOQUEO_CAMPO_DESCRIPCION_WEB: this.configuracion.PV_BLOQUEO_CAMPO_DESCRIPCION_WEB ? 'S' : 'N',
          PV_PERMISOS_EXTRA_PROVEEDOR: this.configuracion.PV_PERMISOS_EXTRA_PROVEEDOR ? 'S' : 'N',
          PV_IMPORTACION_CERRADAS: this.configuracion.PV_IMPORTACION_CERRADAS ? 'S' : 'N',
          PV_TRANSITO_ESTADOS_PROVEEDOR: this.configuracion.PV_TRANSITO_ESTADOS_PROVEEDOR ? 'S' : 'N',
          PV_ALTA_ACTOR_PROVEEDOR: this.configuracion.PV_ALTA_ACTOR_PROVEEDOR ? 'S' : 'N',
        }

        console.log(this.configuracion)

        await this.guardarConfiguracion(obj)
        if (this.configuracion.deletePromotionsProveedor === true) {
          await this.delPromotionsProvider()
        }
        await this.guardarTiposSolicitudes(this.configuracion.tiposSolicitudes)
        await this.guardarEstructuraDescargaDocumentos(this.configuracion.estructuraDescargaDocumentos)
        await this.guardarPromocionesTiposVisita(this.configuracion.promocionesTipoVisita)
        await this.guardarPromocionesTiposVisitaWeb(this.configuracion.promocionesTipoVisitaWeb)
        await this.guardarPromocionesTiposSolicitudCliente(this.configuracion.promocionesTipoSolicitudCliente)
        await this.guardarPromocionesTiposSolicitudClienteWeb(this.configuracion.promocionesTipoSolicitudClienteWeb)
        await this.loadConfiguracion()
        await this.getTiposSolicitudes()
        await this.loadTiposVisita()
       
        await this.obtenerPromocionesTiposVisita('APP')
        await this.obtenerPromocionesTiposVisita('WEB')
        
        await this.obtenerPromocionesTiposSolicitudCliente('APP')
        await this.obtenerPromocionesTiposSolicitudCliente('WEB')
       
        this.inicializarObjetoConfig()
        // Actualizar tipos de visita disponible para el idubapi
        this.actualizarPermisosActorVisitasPV()

        this.cambiado = this.cambiado.map(() => { return false })
        this.cambiadoAlert = false
        this.addAlert({ texto: this.$t('datosGuardadosConExito'), color: 'success' })
      } catch (error) {
        console.log(error)
        this.addAlert({ texto: this.$t('errorGuardadoDatos'), color: 'error' })
      }
      this.saving = false
    },
    actualizarPermisosActorVisitasPV () {
      try {
        // Crear objeto con los tipos de incidencia seleccionados
        let obj = {
          PV_TIPO_INCIDENCIA_ALQ: this.configuracion.tiposIncidenciaAlquiler.join('|'),
          PV_TIPO_INCIDENCIA_SIN_OPER: this.configuracion.tiposIncidenciaSinOperacion.join('|'),
          PV_TIPO_INCIDENCIA_VTA: this.configuracion.tiposIncidenciaVenta.join('|')
        };
        
        // Llamar a la mutación para actualizar el estado
        this.$store.commit('login/updatePermisosActorVisitasPV', obj);
      } catch (error) {
        console.error("Error en actualizarPermisosActorVisitasPV:", error);
      }
    }
  }
}
</script>
